




































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { mapActions, mapGetters } from "vuex"
import { Input } from "element-ui";

@Component({
    ...mapGetters(["account", "useBackup"]),
    ...mapActions(["login", "logout", "toggleBackup"])
})
export default class Login extends Vue {
    isRemember = true;
    loginId: string = "";
    pwd: string = "";
    // 判断是否是switch登录
    isSwitch: boolean = false;

    mounted() {
        this.$utils.focusFirstInput();
    }

    toPwd() {
        (<Input>this.$refs.pwdInput).focus();
    }

    async loginAccount() {
        if (process.env.VUE_APP_TITLE === "jzs") {
            Vue.axios.defaults.baseURL = "https://acloud.hongfund.com/api/";
            localStorage.setItem("jzsBase", "https://acloud.hongfund.com/api/");
        }
        let url, data;
        if (this.isSwitch) {
            url = "accounts/switch";
            data = {
                loginId: this.loginId,
                hashPassword: this.pwd,
                token: localStorage.getItem("token")
            }
        } else {
            url = "accounts/login";
            data = {
                loginId: this.loginId,
                hashPassword: this.pwd
            }
        }
        // localStorage.setItem("isRemember", true);

        Vue.axios({
            url: url,
            method: "POST",
            data: data
        }).then(res => {
            this.$store.dispatch("login", res.data);
            this.$store.dispatch("changeCurrentIcon", "记账");
            this.$store.dispatch("changeLink", [
                { url: "/accountbooklist", name: "客户列表" },
                { url: "/dashboard", name: "进度监测" }
            ]);
            if (this.$store.state.account.role === "会计" || this.$store.state.account.role === "助理") {
                this.$router.push({ path: "/accountbooklist" });
            } else {
                this.$router.push({ path: "/dashboard" });
            }
            localStorage.removeItem("isDisableTax")
            localStorage.setItem("showNotice", "true");
            localStorage.setItem("freeDays", res.data.freeDays);
            if(res.data.adminAccount) {
                console.log(res.data.adminAccount)
                localStorage.setItem("isDisableTax", res.data.adminAccount.isDisableTax.toString());
            }
            if(localStorage.getItem("isFreeDay") != "true"){
                let isJzs = process.env.VUE_APP_TITLE === "jzs";
                if(isJzs && this.$store.state.account.role === "管理员" && res.data.freeDays >0){
                    let msg = "试用" + res.data.freeDays + "天到期！"
                    this.$message({
                        showClose: false,
                        duration: 0,
                        message: msg,
                        type: "error"
                    });
                    localStorage.setItem("isFreeDay", "true");
                }
            }
            this.$emit("showNot", true)
        })
    }
    logswitch() {
        this.isSwitch = true;
        this.$store.dispatch("logout");
    }
    logout() {
        this.$store.dispatch("logout");
		this.$router.push("/login");
		localStorage.clear()
    }

    showPwd = false;
    showCode = true;
}
